type SingleSelectFieldOption = {
	value: string;
	id: string;
};

const findValueInAllowedValues = (value: string | number, allowedValues: unknown) => {
	if (!Array.isArray(allowedValues)) return null;
	for (const isValue of allowedValues) {
		if (isValue.id === value.toString()) {
			return {
				value: isValue.value,
				id: isValue.id,
			};
		}
	}
	return null;
};

export const getSingleSelectFieldValue = ({
	defaultValue,
	allowedValues,
}: {
	defaultValue: unknown;
	allowedValues: unknown;
}): SingleSelectFieldOption | null => {
	if (Array.isArray(defaultValue) && defaultValue.length > 0) {
		if (typeof defaultValue[0] === 'string' || typeof defaultValue[0] === 'number')
			return findValueInAllowedValues(defaultValue[0], allowedValues);
	}
	if (typeof defaultValue === 'string' || typeof defaultValue === 'number') {
		return findValueInAllowedValues(defaultValue, allowedValues);
	}
	return null;
};
